import React, { createContext, useContext } from 'react'
import { User, Tenant } from 'types'

export const CurrentUserContext = createContext<User | null>(null)
export const CurrentTenantContext = createContext<Tenant | null>(null)
export type CurrentUserContextProviderProps = {
  currentUser?: User
  tenant?: Tenant
  children: React.ReactNode
}

export const CurrentUserContextProvider: React.FC<
  CurrentUserContextProviderProps
> = ({ currentUser = null, tenant = null, children }) => {
  return (
    <CurrentUserContext.Provider value={currentUser}>
      <CurrentTenantContext.Provider value={tenant}>
        {children}
      </CurrentTenantContext.Provider>
    </CurrentUserContext.Provider>
  )
}

export const useCurrentUserContext = () => useContext(CurrentUserContext)
